export type NavItem = { to: string; label: string };
export type NavGroup = { title: string; items: NavItem[] };

export const navGroups: NavGroup[] = [
    {
        title: "Start",
        items: [{ to: "/", label: "Overview" }],
    },
    {
        title: "Foundations",
        items: [
            { to: "/foundations/principles", label: "Principles" },
            { to: "/foundations/tokens", label: "Design Tokens" },
            { to: "/foundations/color", label: "Color" },
            { to: "/foundations/typography", label: "Typography" },
            { to: "/foundations/layout", label: "Layout & Grid" },
            { to: "/foundations/spacing", label: "Spacing & Sizing" },
            { to: "/foundations/radius", label: "Radius & Borders" },
            { to: "/foundations/elevation", label: "Elevation" },
            { to: "/foundations/iconography", label: "Iconography" },
            { to: "/foundations/motion", label: "Motion" },
        ],
    },
    {
        title: "Components",
        items: [
            { to: "/components/states", label: "Component States" },
            { to: "/components/buttons", label: "Buttons" },
            { to: "/components/forms", label: "Form Controls" },
            { to: "/components/tables", label: "Tables & Data" },
            { to: "/components/cards", label: "Cards & Containers" },
            { to: "/components/badges", label: "Badges & Status" },
            { to: "/components/navigation", label: "Navigation" },
            { to: "/components/overlays", label: "Overlays" },
            { to: "/components/feedback", label: "Feedback" },
            { to: "/components/async", label: "Loading / Empty / Error" },
            { to: "/components/domain", label: "MAEIZ Domain" },
        ],
    },
    {
        title: "Patterns",
        items: [
            { to: "/patterns/pages", label: "Page Archetypes" },
            { to: "/patterns/search", label: "Search & Filter" },
            { to: "/patterns/responsive", label: "Responsive" },
            { to: "/patterns/accessibility", label: "Accessibility" },
            { to: "/patterns/content", label: "Content & UX Writing" },
            { to: "/patterns/permissions", label: "Role & Permission UX" },
        ],
    },
    {
        title: "Governance",
        items: [
            { to: "/governance/inventory", label: "Component Inventory" },
            { to: "/governance/implementation", label: "Implementation" },
            { to: "/governance/migration", label: "Migration" },
            { to: "/governance/audit", label: "Consistency Audit" },
        ],
    },
];
